<template>
    <div v-if="isMounted">
        <div class="m-portlet left">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption" style="width: 100%">
                    <div class="m-portlet__head-title" style="width: 100%">
                        <h5>筛选条件</h5>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body">
                <el-form>
                    <el-form-item>
                        <el-button style="float:left;" size="mini" type="success" @click="createExam()"
                                   v-if="powers.includes(33)">新建考试
                        </el-button>
                    </el-form-item>
                    <el-form-item label="学校">
                        <el-select v-model="form.school_id" clearable filterable remote
                                   :remote-method="handleSearchSchool" placeholder="请选择学校"
                                   @change="changeCondition()">
                            <el-option
                                    v-for="item in filter.schools"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="年级">
                        <el-select v-model="form.grade_id" clearable filterable remote
                                   placeholder="请选择年级"
                                   @change="changeCondition()">
                            <el-option
                                    v-for="item in filter.grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="考试">
                        <el-select v-model="form.exam_id" clearable filterable remote :remote-method="handleSearchExam"
                                   placeholder="请选择考试"
                                   @change="handleIndexSchoolExam()">
                            <el-option
                                    v-for="item in filter.exams"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="m-portlet right">
            <div class="m-portlet__body">
                <table class="table" v-loading="loading">
                    <thead>
                    <tr>
                        <th>学校</th>
                        <th>年级</th>
                        <th>考试</th>
                        <th>开始时间</th>
                        <th v-if="powers.includes(34)">操作</th>
                    </tr>

                    </thead>
                    <tbody>
                    <tr v-for="item in schoolExams" :key="item.id">
                        <td>{{item.school_name}}</td>
                        <td>{{item.grade_name}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.date}}</td>

                        <td>
                            <el-button size="mini" @click="handleSchoolExamInformation(item)"
                                       v-if="powers.includes(34)">查看详情
                            </el-button>
                            <el-button size="mini" @click="handleDelSchoolExam(item,item.name)"
                                       :loading="button_loading"
                                       v-if="powers.includes(36)">删除
                            </el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <div class="text-center m-t-10">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "schoolExam-list",
        data() {
            return {
                path: "/exam/school/list",
                loading: 'true',
                isMounted: false,
                button_loading: false,
                filter: {
                    schools: [],
                    exams: [],
                    grades: [],
                    subjects: [],
                    schoolClasses: [],
                },
                form: {
                    school_id: '',
                    exam_id: '',
                    grade_id: '',

                },
                schoolExams: {},
                currentPage: 1,
                currentPageSize: 10,
                total: 1,

                createSchoolExam: {
                    outlineForm: {
                        school_id: '',
                        organizationService_id: '',
                        grade_id: '',
                        subjects: [{
                            id: '',
                            classAvgScore: '',
                            gradeAvgScore: '',
                            areaAvgScore: '',
                        }],
                        examDate: '',
                        exam_name: '',
                        newSchool_name: '',
                        data: ''
                    },
                    school_status: true,
                    button_loading: false,
                },
            }
        },
        created() {

        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            }
        },
        mounted() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$func.connectData(this.$data, this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path].schoolExamList)
            this.handleCreate();
            this.handleShow();
            this.handleIndexSchoolExam();
            this.isMounted = true
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path, 'init', {'currentPageSize': 10, 'currentPage': 1});
            },
            handleData(event, data, status) {
                switch (event) {
                    case 'init':
                        this.filter.schools = data.schools;
                        this.filter.exams = data.exams;
                        this.filter.grades = data.grades;
                        this.filter.subjects = data.subjects;
                        this.filter.schoolClasses = data.schoolClasses;
                        this.loading = false;
                        break;
                    case 'list':
                        if (Object.keys(data.schoolExams).length > 0) {
                            this.schoolExams = data.schoolExams
                        } else {
                            this.schoolExams = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'delete_schoolExam':
                        if (status == 'success') {
                            this.$delete(this.schoolExams, data.schoolExam_id)
                            this.$message({
                                message: '删除学校考试成功',
                                type: 'success'
                            });
                        }
                        this.button_loading = false;
                        break;
                    case 'searchSchool':
                        this.filter.schools = data.searchData;
                        break;
                    case 'searchExam':
                        this.filter.exams = data.searchData;
                        break;
                    case 'create_schoolExam':
                        if (status == 'success') {
                            this.$message({
                                message: this.createSchoolExam.outlineForm.exam_name + '添加成功',
                                type: 'success'
                            });
                            this.createSchoolExam.button_loading = false;
                            this.createSchoolExam.outlineForm = {
                                school_id: '',
                                organizationService_id: '',
                                grade_id: '',
                                subjects: [{
                                    id: '',
                                    classAvgScore: '',
                                    gradeAvgScore: '',
                                    areaAvgScore: '',
                                }],
                                examDate: '',
                                exam_name: '',
                                newSchool_name: '',
                                data: ''
                            };
                            this.$set(this.schoolExams, data.schoolExam.id, data.schoolExam)
                        }
                        break;
                }
            },
            handleIndexSchoolExam(currentPage = 1, currentPageSize = 10) {
                this.$wApi.send(this.path, 'list', {
                    'currentPageSize': currentPageSize,
                    'currentPage': currentPage,
                    'form': this.form
                });
            },
            createExam() {
                this.$Win.openModal('Dialog_CreateSchoolExam', 1100, 500, '新建学校考试');
            },
            handleSchoolExamInformation(schoolExam) {
                this.$store.dispatch('addView', {
                    'title': schoolExam.name + '详情',
                    'path': '/schoolExam' + schoolExam.id,
                    'closable': true
                });
                this.router.push({path: '/schoolExam/' + schoolExam.id})
            },
            handleDelSchoolExam(item, name) {
                this.button_loading = true;
                this.$confirm('删除“' + name + '”会同时删除已记录的学生考试成绩，是否删除?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'delete_schoolExam', {'schoolExam_id': item.id});
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.path, 'search', {
                    'type': 'schoolKeyName',
                    'schoolKeyName': query,
                });
            },
            handleSearchExam(query = '') {
                this.$wApi.send(this.path, 'search', {
                    'type': 'schoolExamKeyName',
                    'schoolExamKeyName': query,
                    'school_id': this.form.school_id,
                    'grade_id': this.form.grade_id
                });
            },
            changeCondition() {
                this.currentPage = 1;
                this.handleSearchExam();
                this.handleIndexSchoolExam();
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexSchoolExam(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexSchoolExam(this.currentPage, this.currentPageSize)
            }
        }
    }
</script>

<style scoped>
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>
